module.exports = __webpack_public_path__ + "static/media/Gallery 1.9bfe9581.svg";